export {default as voronoi} from "./src/voronoi";



//////////////////
// WEBPACK FOOTER
// ./~/d3-voronoi/index.js
// module id = 299
// module chunks = 0